var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { level: 2, styling: "page-title" } }, [
        _vm._v("Kontakt zur Garde"),
      ]),
      _c("Seperator"),
      _c("p", [
        _vm._v(
          " Sie möchten mit uns in Kontakt treten? Wir freuen uns auf ihre E-Mail. "
        ),
      ]),
      _c(
        "div",
        { attrs: { id: "kontakte" } },
        [_c("Contacts", { attrs: { contacts: [_vm.praes] } })],
        1
      ),
      _c("Seperator"),
      _c("SocialMedia"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }